var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("ATUALIZAR RECEÇÃO")]),_c('UpdateReception')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }